var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("div", { staticClass: "bc_ico" }, [
        _c("a", { attrs: { href: "javascript:" }, on: { click: _vm.goMain } }, [
          _vm._v("Home")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("TITLE.MYKNOWLEDGE.USERPREFERENCES")) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "pg_title" }, [
        _vm._v(_vm._s(_vm.$t("TITLE.MYKNOWLEDGE.USERPREFERENCES")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid_wrap" }, [
        _c("div", { staticClass: "sub_tit w100p" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("TITLE.GLOBAL.MYMENUS")) +
              "\n                "
          ),
          !_vm.isMobile
            ? _c(
                "a",
                {
                  staticClass: "ico_config",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                  },
                  on: { click: _vm.btnMyMenuConfig }
                },
                [
                  _c("span", { staticClass: "sr_only" }, [
                    _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                  ])
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "scroll_table" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH1")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH2")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH3")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.mySettingMenu, function(item) {
                return _c("tr", [
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA1))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA2))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA3))
                  ])
                ])
              }),
              _vm._v(" "),
              _vm.mySettingMenu.length == 0
                ? _c("tr", [
                    _c("td", { staticClass: "tC", attrs: { conspan: "3" } }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid_wrap" }, [
        _c("div", { staticClass: "sub_tit mt-25 w100p" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("FIELD.GLOBAL.ETC.055")) +
              "\n                "
          ),
          !_vm.isMobile
            ? _c(
                "a",
                {
                  staticClass: "ico_config",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                  },
                  on: { click: _vm.btnCatConfig }
                },
                [
                  _c("span", { staticClass: "sr_only" }, [
                    _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                  ])
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "scroll_table" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH1")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH2")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH3")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.mySettingCategory, function(item) {
                return _c("tr", [
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA1))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA2))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "tC" }, [
                    _vm._v(_vm._s(item.COLDATA3))
                  ])
                ])
              }),
              _vm._v(" "),
              _vm.mySettingCategory.length === 0
                ? _c("tr", [
                    _c("td", { staticClass: "tC", attrs: { conspan: "3" } }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inquiry_content_wrap" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: Number(_vm.deptLevelCd) > 1,
                expression: "Number(deptLevelCd) > 1"
              }
            ],
            staticClass: "grid_wrap"
          },
          [
            _c("div", { staticClass: "sub_tit mt-25 w100p" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("FIELD.GLOBAL.ETC.054")) +
                  "\n                    "
              ),
              !_vm.isMobile
                ? _c(
                    "a",
                    {
                      staticClass: "ico_config",
                      attrs: {
                        href: "javascript:",
                        title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                      },
                      on: { click: _vm.btnDashboardConfig }
                    },
                    [
                      _c("span", { staticClass: "sr_only" }, [
                        _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("em", { staticClass: "ico_info" }, [
                    _c("i", { staticClass: "tooltip" }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.038")))
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "scroll_table" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.048")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY")))]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.CONTENTS.TYPE")))
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.mySettingDashboard, function(item) {
                    return _c("tr", [
                      _c("td", { staticClass: "tC" }, [
                        _vm._v(_vm._s(item.COLDATA1))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _vm._v(_vm._s(item.COLDATA2))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _vm._v(_vm._s(item.COLDATA3))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tC" }, [
                        _vm._v(_vm._s(item.COLDATA4))
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm.mySettingDashboard.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "tC", attrs: { conspan: "4" } },
                          [_vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid_wrap" }, [
          _c("div", { staticClass: "sub_tit mt-25 w100p" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("TITLE.DASHBOARD.MAIN.CONTENTS")) +
                "\n                    "
            ),
            !_vm.isMobile
              ? _c(
                  "a",
                  {
                    staticClass: "ico_config",
                    attrs: {
                      href: "javascript:",
                      title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                    },
                    on: { click: _vm.btnContentsConfig }
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [
                      _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("em", { staticClass: "ico_info" }, [
                  _c("i", { staticClass: "tooltip" }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.037")))
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "scroll_table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.043")))])
              ])
            ]),
            _vm._v(" "),
            _vm.mySettingContent.length > 0
              ? _c("tbody", [
                  _c("tr", [
                    _c("td", { staticClass: "tC" }, [
                      _vm._v(
                        "1. " +
                          _vm._s(
                            this.getContentName(
                              _vm.mySettingContent[0].COLDATA1
                            )
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "tC" }, [
                      _vm._v(
                        "2. " +
                          _vm._s(
                            this.getContentName(
                              _vm.mySettingContent[0].COLDATA2
                            )
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "tC" }, [
                      _vm._v(
                        "3. " +
                          _vm._s(
                            this.getContentName(
                              _vm.mySettingContent[0].COLDATA3
                            )
                          )
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.mySettingContent.length === 0
              ? _c("tbody", [
                  _c("tr", [
                    _c("td", { staticClass: "tC" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt-25 w100p" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("SUBTITLE.FAST.OTHERS")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "data_table" }, [
          _vm._m(4),
          _vm._v(" "),
          _vm.mySettingOther.length > 0
            ? _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.MYKNOWLEDGE.LISTOFCOUNT")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.mySettingOther[0].COLDATA1))]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.SURVEY.SUMMARY.LANG")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.mySettingOther[0].COLDATA2))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.USER.ENV.TIME.ZONE")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.mySettingOther[0].COLDATA3))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.mySettingOther[0].COLDATA4))])
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "33.3%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "33.3%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "33.3%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "33.3%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "150" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73fcb904", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fcb904","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/myKnowledge/userPreferences/UserPreferencesDetail.vue
// module id = d7CI
// module chunks = 0